export default __webpack_public_path__ + "bb86a77c9dcc465f8e77e6af6fdfb690.svg";